module.exports = __webpack_public_path__ + "media/ck_pano.1f0897cb.mp4";